module.exports = __webpack_public_path__ + "static/media/Alan Shelby_1619531786612.251f540e.jpeg";